import { Document as DocumentType } from 'src/types/models';
import SynchronousDocumentOperation from './synchronous';

export default class SetSpellCheckOperation extends SynchronousDocumentOperation {
  readonly type = 'set-spell-check';

  isEnabled: boolean;

  constructor(documentId: string, isEnabled = true) {
    super(documentId);
    this.isEnabled = isEnabled;
  }

  apply(document: DocumentType): DocumentType {
    return {
      ...document,
      meta: {
        ...document.meta,
        spellCheck: this.isEnabled,
      },
    };
  }
}
